import { Form, Input, Typography } from "antd";
export const CitiesInput = ({
  name,
  label,
  type,
  size,
  disabled,
  required,
  message,
  value,
  placeholder,
  textArea,
  validator,
  isControlled,
  ...props
}) => {
  return (
    <Form.Item
      name={isControlled ? undefined : name}
      label={<Typography.Text strong>{label}</Typography.Text>}
      rules={
        validator
          ? [
              {
                required: required,
                message: message,
              },
              validator,
            ]
          : [
              {
                required: required,
                message: message,
              },
            ]
      }
    >
      {textArea ? (
        <Input.TextArea
          placeholder={placeholder || ""}
          value={value}
          {...props}
        />
      ) : type === "password" ? (
        <Input.Password
          placeholder={placeholder || ""}
          value={value}
          size={size || "middle"}
          disabled={disabled || false}
          {...props}
        />
      ) : (
        <Input
          type={type || "text"}
          placeholder={placeholder || ""}
          value={value}
          size={size || "middle"}
          disabled={disabled || false}
          {...props}
        />
      )}
    </Form.Item>
  );
};
